<template>
  <div v-if="show" class="container p8">
    <div>
      <!-- <div class="flex around align-center wrap column">
        <div v-if="enableQty" class="flex xs-font align-center column">
          <label><code>Quantity</code></label>
          <div class="flex center"><i class="fas fa-lg fa-arrow-down r8" @click="qty > 0 ? qty-- : null"></i><input class="sm-input qty-input r8" type="number" v-model.number="qty"><i class="fas fa-lg fa-arrow-up" @click="qty++"></i></div>
        </div>
      </div> -->
      <div
        class="p4 flexy"
        v-if="
          item.purchases.auction &&
          +new Date(item.purchases['auction end']) > Date.now()
        "
      >
        <div class="flex between b16 auction wrap">
          <h2>Auction</h2>
          <div class="sm-font align-end flex column">
            <span
              >High Bid: <b class="lg-font">${{ highbid[0] }}</b></span
            >
            <div>
              Ending <b><itime :timestamp="item.purchases['auction end']" /></b>
            </div>
            <span
              >Time left:
              <b>
                {{
                  timeremaining.toString().length > 9
                    ? Math.round(timeremaining / 1000 / 60 / 60 / 24 / 7) +
                      " weeks"
                    : timeremaining.toString().length > 8
                    ? Math.round(timeremaining / 1000 / 60 / 60 / 24) + " days"
                    : timeremaining.toString().length > 7
                    ? Math.round(timeremaining / 1000 / 60 / 60) + " hours"
                    : timeremaining.toString().length > 6
                    ? Math.round(timeremaining / 1000 / 60) + " minutes"
                    : Math.round(timeremaining / 1000) + " seconds"
                }} </b
              >| Bids: <b>{{ highbid[2] }}</b></span
            >
          </div>
        </div>
        <div class="container success p4 b16" v-if="highbid[1] == userhash">
          <b class="b16 t16"
            >You are the highest bidder.</b
          >
          <div class="container p8">
            <div class="">
              <div class="warn-text b8">
                Careful! Since you are the highest bidder, only submit a higher
                bid if you really mean to.
              </div>
              <label
                :for="`${item.type}_${item.id}_highbidoverride`"
                class="flex align-center sm-font"
              >
                <input
                  type="checkbox"
                  v-model="highbidoverride"
                  :id="`${item.type}_${item.id}_highbidoverride`"
                />Confirm you wish to increase your bid.
              </label>
            </div>
          </div>
        </div>
        <div>
          <div>
            <i
              v-if="item.purchases.currency"
              :class="`r4 fas fa-${
                item.purchases.currency.toLowerCase() === 'usd'
                  ? 'dollar-sign'
                  : ''
              }`"
            ></i>
            <input
              @click="
                bidamount = +highbid[0] + 1 || +item.purchases['minimum bid']
              "
              :min="highbid ? +highbid[0] + 1 : +item.purchases['minimum bid']"
              class="md-input b4"
              type="number"
              v-model="bidamount"
              placeholder="Bid"
            />
            {{
              "( min bid $" +
              (+highbid[0] + 1 || +item.purchases["minimum bid"]) +
              " )"
            }}
          </div>
          <button
            @click="
              show = false;
              !item.bids ? (item.bids = {}) : null;
              $store
                .dispatch('util', { type: 'hash', body: $store.state.auth.uid })
                .then((h) => {
                  $set(item.bids, bidamount, h);
                  $store
                    .dispatch('update', {
                      id: item.id,
                      type: item.type,
                      data: item,
                    })
                    .then(() => {
                      $store.state.user[$store.state.auth.uid].auctions =
                        $store.state.user[$store.state.auth.uid].auctions || {};
                      $store.state.user[$store.state.auth.uid].auctions[item.type+'_'+item.id] = bidamount
                      $store
                        .dispatch('update', {
                          type: 'user',
                          id: $store.state.auth.uid,
                          data: $store.state.user[$store.state.auth.uid],
                        })
                        .then(() =>
                          $set(
                            $store.state.counts,
                            'buy',
                            $store.state.counts.buy + 1 || 2
                          )
                        );
                    });
                  show = true;
                });
            "
            :disabled="
              !bidamount || (highbid[1] == userhash && !highbidoverride)
            "
            class="flex fill wrap align-center update xl-font p16 box-glow b16"
          >
            Commit Bid
          </button>
        </div>
      </div>
      <div
        v-if="!item.purchases.auction || (item.purchases['buy now'] && !item.purchases['auction complete'])"
        class="p4 flexy"
      >
        <!-- Variations Selection -->
        <div
          v-if="item.purchases.variations && typeof item.purchases.variations === 'object' && Object.keys(item.purchases.variations).length > 0"
          class="flex column b16 p8 border"
        >
          <h3 class="b8">Select Variations</h3>
          <div
            v-for="(variationType, varKey) in Object.keys(item.purchases.variations).sort((a, b) => {
              const priorities = item.purchases.variations_priorities || {};
              const priorityA = priorities[a] !== undefined ? priorities[a] : 0;
              const priorityB = priorities[b] !== undefined ? priorities[b] : 0;
              return priorityA - priorityB;
            })"
            :key="varKey"
            class="flex column b8"
          >
            <label class="xs-font b4">{{ variationType }}</label>
            <select
              class="xs-font xs-input"
              v-model="selectedVariations[variationType]"
              @change="updateVariationCost()"
            >
              <option value="">Select {{ variationType }}</option>
              <option
                v-for="(variation, varIndex) in item.purchases.variations[variationType]"
                :key="varIndex"
                :value="varIndex"
              >
                {{ variation.description || variation.name || variation }}
              </option>
            </select>
          </div>
        </div>
        <div class="flex align-center between">
          <h2>Purchase</h2>
          <span class="flex align-center r8">
            <i
              v-if="item.purchases.currency"
              :class="`r4 fas fa-${
                item.purchases.currency.toLowerCase() === 'usd'
                  ? 'dollar-sign'
                  : ''
              }`"
            ></i>
            <b
              v-if="item.purchases.cost && !item.purchases.nameprice"
              class="xl-font"
              >{{
                item.purchases.cost
                  ? (qty * (Number(item.purchases.cost) + Number(variationCost)))
                  : "Enter an amount"
              }}</b
            >
            <b v-else class="p4">
              <input
                class=""
                type="tel"
                v-model="customAmount"
                placeholder="Enter Amount"
              />
            </b>
          </span>
          <div
            class="xs-font flex column"
            v-if="item.purchases['shipping and handling']"
          >
            
            <div v-if="item.purchases['shipping and handling'] > 0">
              + ${{ qty * Number(item.purchases["shipping and handling"]) }} S&H
            </div>
          </div>
        </div>
        <div v-if="$store.state.auth.uid && !isEmailVerified" class="warn-text p8 b8">
          <p class="xs-font">Please verify your email to add items to cart.</p>
          <a @click="sendVerificationEmail" class="underline xs-font">Click here to send verification email</a>
        </div>
        <button
          v-if="
            !item.purchases.auction ||
            (item.purchases.auction && item.purchases['buy now'])
          "
          :disabled="(!item.purchases.cost && !customAmount) || ($store.state.auth.uid && !isEmailVerified)"
          class="fill flex wrap align-center success xl-font p16 box-glow"
          type="button"
          @click="
            $store.state.auth.uid
              ? addToCart(item, qty)
              : $set(
                  $store.state.show,
                  'auth',
                  true
                )
          "
        >
          <i class="fas fa-shopping-cart r8"></i
          >{{ $store.state.auth.uid ? (isEmailVerified ? "Add to Cart" : "Verify Email to Buy") : "Log in to buy" }}
        </button>
      </div>
      <div v-else>
        <div class=" success-text p4 b16" v-if="highbid[1] == userhash && +new Date(item.purchases['auction end']).getTime() <= +new Date().getTime()">
          Congratulations, you won this auction. Check order details in 
              <router-link class="border-bottom indicate-text" :to="{path: '/profile', query: {section: 'money', tab: 'auctions'}}"> 
                Profile  > <i class="r4 far fa-money-bill-alt"></i>Money > <i class="r4 fa fa-gavel"></i>Auctions</router-link>
        </div>
        <p v-else-if="+new Date(item.purchases['auction end']).getTime() > +new Date().getTime()">Item unattainable</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "buy",
  props: { item: { type: [Object, Array] } },
  computed: {
    highbid() {
      if (!this.item.purchases.auction) return false;
      else {
        let bidarray =
          this.item.bids &&
          Object.entries(this.item.bids)
            .map((x) => +x[0])
            .sort(function (a, b) {
              return b - a;
            });
        return this.item.bids
          ? [bidarray[0], this.item.bids[bidarray[0] + ""], bidarray.length]
          : this.item.purchases["minimum bid"];
      }
    },
    timeremaining() {
      return (
        this.item.purchases &&
        this.item.purchases.auction &&
        +new Date(this.item.purchases["auction end"]).getTime() >=
          +Date.now() &&
        +new Date(this.item.purchases["auction end"]).getTime() - +Date.now()
      );
    },
    isEmailVerified() {
      if (!this.$store.state.auth.uid) return true;
      const user = this.$store.state.auth;
      // Social logins (Google, Facebook, etc.) are considered verified
      if (user.providerData && user.providerData.length > 0) {
        const hasSocialProvider = user.providerData.some(p => p.providerId !== 'password');
        if (hasSocialProvider) return true;
      }
      // If user has provider field (from social login), consider verified
      if (user.provider && user.provider !== 'email') return true;
      // Check if email is verified for password-based logins
      if (user.emailVerified === true) return true;
      // If no email or no provider data, assume not verified for password logins
      return false;
    },
  },
  data() {
    return {
      customAmount: "",
      bidamount: "",
      enableQty: false,
      qty: 1,
      showError: false,
      userhash: "",
      highbidoverride: false, // to confirm a higher bid if already high-bidder
      show: false,
      selectedVariations: {},
      variationCost: 0,
    };
  },
  methods: {
    async getuserhash() {
      return await this.$store
        .dispatch("util", { type: "hash", body: this.$store.state.auth.uid })
        .then((h) => this.$set(this, "userhash", h));
    },
    sendVerificationEmail() {
      this.$store.dispatch('auth', { type: 'sendEmailVerification' })
        .then(() => {
          alert('Verification email sent! Please check your inbox.');
        })
        .catch((error) => {
          console.error('Error sending verification email:', error);
          alert('Error sending verification email. Please try again.');
        });
    },
    updateVariationCost() {
      let additionalCost = 0;
      const variations = this.item.purchases.variations || {};
      
      Object.keys(this.selectedVariations).forEach(variationType => {
        const selectedIndex = this.selectedVariations[variationType];
        if (selectedIndex !== '' && selectedIndex !== null && selectedIndex !== undefined && variations[variationType] && variations[variationType][selectedIndex]) {
          const variation = variations[variationType][selectedIndex];
          if (variation.cost !== undefined) {
            additionalCost += Number(variation.cost) || 0;
          }
        }
      });
      
      this.variationCost = additionalCost;
    },
    addToCart(item, qty) {
      console.log('addToCart called with:', item, qty);
      
      // Create a copy of purchases with selected variations
      const purchaseData = JSON.parse(JSON.stringify(item.purchases));
      
      // Add selected variations to purchase data
      if (this.selectedVariations && Object.keys(this.selectedVariations).length > 0) {
        purchaseData.selectedVariations = {};
        const variations = item.purchases.variations || {};
        let baseCost = Number(purchaseData.cost) || 0;
        
        Object.keys(this.selectedVariations).forEach(variationType => {
          const selectedIndex = this.selectedVariations[variationType];
          if (selectedIndex !== '' && selectedIndex !== null && variations[variationType] && variations[variationType][selectedIndex]) {
            // Store only the variation data, not the full object reference
            const variation = variations[variationType][selectedIndex];
            purchaseData.selectedVariations[variationType] = JSON.parse(JSON.stringify(variation));
            // Update cost if variation has a cost
            if (variation.cost !== undefined) {
              const variationCost = Number(variation.cost) || 0;
              baseCost = baseCost + variationCost;
            }
          }
        });
        
        purchaseData.cost = baseCost;
      }
      
      if (!purchaseData.cost) {
        purchaseData.cost = this.customAmount;
      }
      // if user is logged in,
      if (this.$store.state.user[this.$store.state.auth.uid]) {
        console.log('User is logged in, adding to cart');
        // and does not have a cart already,

        if (!this.$store.state.user[this.$store.state.auth.uid].cart) {
          this.$set(
            this.$store.state.user[this.$store.state.auth.uid],
            "cart",
            {
              [item.id]: [
                item.type,
                item.id,
                purchaseData,
                qty,
                item.user,
                item.basics.title,
              ],
            }
          );

          // or does have items in the cart
        } else if (
          this.$store.state.user[this.$store.state.auth.uid].cart[item.id]
        ) {
          // Check if variations match - if not, create separate cart entry
          const existingPurchase = this.$store.state.user[this.$store.state.auth.uid].cart[item.id][2];
          const variationsMatch = JSON.stringify(existingPurchase.selectedVariations || {}) === 
                                 JSON.stringify(purchaseData.selectedVariations || {});
          
          if (variationsMatch && existingPurchase.cost === purchaseData.cost) {
            this.$set(
              this.$store.state.user[this.$store.state.auth.uid].cart,
              item.id,
              [
                item.type,
                item.id,
                purchaseData,
                this.$store.state.user[this.$store.state.auth.uid].cart[
                  item.id
                ][3] + qty,
                item.user,
                item.basics.title,
              ]
            );
          } else {
            // Different variations - create new cart entry with variant suffix
            const variantKey = item.id + '-variant-' + Date.now();
            this.$set(
              this.$store.state.user[this.$store.state.auth.uid].cart,
              variantKey,
              [
                item.type,
                item.id,
                purchaseData,
                qty,
                item.user,
                item.basics.title,
              ]
            );
          }

          // else user has cart but not this item
        } else {
          this.$set(
            this.$store.state.user[this.$store.state.auth.uid].cart,
            item.id,
            [
              item.type,
              item.id,
              purchaseData,
              qty,
              item.user,
              item.basics.title,
            ]
          );
        }
        delete this.$store.state.user[this.$store.state.auth.uid].user; // remove this.user stragler
        this.$store.state.user[this.$store.state.auth.uid].type = "user";

        // save updated user data
        var saveObj = {
          type: "user",
          id: this.$store.state.auth.uid,
          // noReload: true,
          data: this.$store.state.user[this.$store.state.auth.uid],
        };
        this.$store.dispatch("update", saveObj).then(() => {
          // cheat to update the cart
          this.$set(this.$store.state.show, "cart", false);
          setTimeout(() => {
            this.$set(this.$store.state.show, "cart", true);
          }, 0);
        });
      } else {
        console.log('User not logged in, adding to anonymous cart');
        this.$store.state.anon.cart = JSON.parse(
          window.localStorage.getItem("cart")
        )
          ? JSON.parse(window.localStorage.getItem("cart"))
          : null;
        !this.$store.state.anon.cart
          ? this.$set(this.$store.state.anon, "cart", {
              [item.id]: {
                [Date.now()]: [
                  item.type,
                  item.id,
                  purchaseData,
                  qty,
                  item.user,
                  item.basics.title,
                ],
              },
            })
          : !this.$store.state.anon.cart[item.id]
          ? this.$set(this.$store.state.anon.cart, item.id, {
              [Date.now()]: [
                item.type,
                item.id,
                purchaseData,
                qty,
                item.user,
                item.basics.title,
              ],
            })
          : this.$set(this.$store.state.anon.cart[item.id], Date.now(), [
              item.type,
              item.id,
              purchaseData,
              qty,
              item.user,
              item.basics.title,
            ]);
        localStorage.setItem(
          "cart",
          JSON.stringify(this.$store.state.anon.cart)
        );
        this.$set(this.$store.state.show, "cart", false);
        setTimeout(() => {
          this.$set(this.$store.state.show, "cart", true);
        }, 0);
      }
    },
  },
  mounted() {
    this.getuserhash();
    this.show = true;
    // Set default variations if they exist
    if (this.item.purchases.variations && this.item.purchases.variations_defaults) {
      const defaults = this.item.purchases.variations_defaults;
      Object.keys(this.item.purchases.variations).forEach(variationType => {
        const defaultIndex = defaults[variationType];
        if (defaultIndex !== undefined && defaultIndex !== null && this.item.purchases.variations[variationType][defaultIndex]) {
          this.$set(this.selectedVariations, variationType, defaultIndex);
        }
      });
      // Update cost with default variations
      this.updateVariationCost();
    }
  },
  watch: {
    customAmount: function (val, oldVal) {
      console.log(val, oldVal);
      this.customAmount = val.replace(/\D/g, "");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
